<template>
  <transition name="modal">
    <div class="loading-panel">
      <LoadingAnimation />
    </div>
  </transition>
</template>

<script>
import LoadingAnimation from "@/components/LoadingAnimation";

export default {
  name: "LoadingPanel",
  components: { LoadingAnimation },
};
</script>

<style lang="scss" scoped>
.loading-panel {
  position: fixed;
  z-index: 9999;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;

  background: $brand-pink;
  display: flex;
  justify-content: center;
  align-items: center;
}
</style>
